import { useRef } from 'react';
import { postMessage } from '../helpers/utils';
import { MESSAGE_TYPES } from '../constants/simulationConstants';

function useResponseTimeout({
  timeout = 30000,
  onTimeout,
  errorMessage = 'AI response timeout. Please try again.'
} = {}) {
  const timeoutRef = useRef(null);

  /**
   * Clears the active timeout timer
   */
  const clearResponseTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  /**
   * Starts the timeout timer
   * If no response is received within the timeout period:
   * 1. Sends error message to parent application
   * 2. Triggers optional onTimeout callback
   * 3. Clears the timeout reference
   */
  const startResponseTimeout = () => {
    clearResponseTimeout();
    timeoutRef.current = setTimeout(() => {
      console.error('[Response Timeout Error]', errorMessage);

      // Send error message to parent application
      postMessage({
        type: MESSAGE_TYPES.CHAT,
        error: errorMessage
      });

      // Trigger optional callback
      if (onTimeout && typeof onTimeout === 'function') {
        onTimeout();
      }

      // Clear the timeout reference
      timeoutRef.current = null;
    }, timeout);
  };

  /**
   * Resets the timeout timer
   * Useful when you want to restart the timer without manually clearing first
   */
  const resetResponseTimeout = () => {
    startResponseTimeout();
  };

  return {
    startResponseTimeout,
    clearResponseTimeout,
    resetResponseTimeout
  };
}

export default useResponseTimeout;
